import './CampaignDetailPage.css';

import { IonContent, IonPage } from '@ionic/react';
import React, { useEffect, useRef, useState } from 'react';
import { RouteComponentProps } from 'react-router';
import { useHistory } from 'react-router-dom';

import AddComment from '../../components/comment/AddComment';
import LayoutGap from '../../layouts/LayoutGap';
import Toolbar from '../../layouts/Toolbar';
import { CampaignCommentsAction, CampaignDonationsAction } from '../../redux/actions/Campaign';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import Comments from '../comments/Comments';
import Description from './Description';
import Donations from './Donations';
import Updates from './Updates';
import Gallery from './Gallery';

interface Props extends RouteComponentProps<{
    campaign_id: string,
    type: string
}> { }

const CampaignDetailPage: React.FC<Props> = ({ match }) => {
    const history = useHistory();
    const dispatch = useAppDispatch();

    const [title, setTitle] = useState("")
    const [subtitle, setSubTitle] = useState("")
    const [activeComponent, setActiveComponent] = useState(null as any)
    const [addCommentButtonVisible, setAddCommentButtonVisible] = useState(false)
    const [showAddCommentModal, setShowAddCommentModal] = useState(false);

    const { loading1, campaignComments } = useAppSelector(state => state.campaignCommentsGet);
    const [comments, setComments] = useState(history.location.state as any);
    const [commentsData, setCommentsData] = useState({ event: null as any, currentPage: 0 });

    const { loading2, campaignDonations } = useAppSelector(state => state.campaignDonationsGet);
    const [donations, setDonations] = useState((history.location.state as any).donations);
    const [donationsData, setDonationsData] = useState({ event: null as any, currentPage: 0 });

    const commentsLoadMore = (e: any) => {
        const currentPage = commentsData.currentPage + 1

        setCommentsData({ event: e, currentPage: currentPage })

        dispatch(CampaignCommentsAction(match.params.campaign_id, currentPage))
    }

    const donationsLoadMore = (e: any) => {
        const currentPage = donationsData.currentPage + 1

        setDonationsData({ event: e, currentPage: currentPage })

        dispatch(CampaignDonationsAction(match.params.campaign_id, currentPage))
    }

    useEffect(() => {
        if (campaignComments != null && !loading1) {
            if (commentsData.event?.target != null) {
                commentsData.event?.target.complete();

                const items = comments.concat(campaignComments.comments);

                commentsData.event.target.disabled = (items.length == campaignComments.commentsTotal);

                setComments(items);

                setActiveComponent(<Comments data={items} loadMore={commentsLoadMore} />)
            }
        }
    }, [loading1])

    useEffect(() => {
        if (campaignDonations != null && !loading2) {
            if (donationsData.event?.target != null) {
                donationsData.event?.target.complete();

                const items = donations.concat(campaignDonations.donations);

                donationsData.event.target!.disabled = (items.length == campaignDonations.donationsTotal);

                setDonations(items);

                setActiveComponent(<Donations data={items} loadMore={donationsLoadMore} />)
            }
        }
    }, [loading2])

    useEffect(() => {
        if (match.params.type == 'gallery') {
            setTitle("تصاویر")
            setActiveComponent(<Gallery images={history.location.state as any} />)
        } else if (match.params.type == 'desc') {
            setTitle("توضیحات")
            setActiveComponent(<Description content={history.location.state as any} />)
        } else if (match.params.type == 'comments') {
            setTitle("نظرات")
            setActiveComponent(<Comments data={comments} loadMore={commentsLoadMore} />)
            setAddCommentButtonVisible(true)
        } else if (match.params.type == 'donations') {
            setTitle("حامیان")
            setSubTitle((history.location.state as any).donationsTotal + " حامی")
            setActiveComponent(<Donations data={donations} loadMore={donationsLoadMore} />)
        } else if (match.params.type == 'updates') {
            setTitle("گزارش ها")
            setSubTitle((history.location.state as any)[0]?.date)
            setActiveComponent(<Updates data={history.location.state as any} changeSubTitle={changeSubTitleHandler} />)
        }
    }, [match])

    const showCommentHandler = () => {
        // window.addEventListener('popstate', hideCommentHandler);
        setShowAddCommentModal(true);
        // history.push("#add-comment")
    }

    const hideCommentHandler = () => {
        // window.removeEventListener('popstate', hideCommentHandler);
        setShowAddCommentModal(false);
        // if (window.location.hash == "#add-comment") {
        // history.goBack();
        // }
    }

    const changeSubTitleHandler = async (subTitle: string) => {
        setSubTitle(subTitle);
    }

    return <IonPage className="campaign-detail">
        <Toolbar title={title} subTitle={subtitle} hasBackButton />

        <LayoutGap />

        <IonContent className="main-content">
            {activeComponent}
        </IonContent>

        {addCommentButtonVisible ?
            <AddComment id={match.params.campaign_id} type="campaign" show={showAddCommentModal} clickShow={showCommentHandler} clickHide={hideCommentHandler} commentPostDone={hideCommentHandler} />
            : null}
    </IonPage>
}

export default CampaignDetailPage